<template>
  <div class="large-navigation-bar" :class="{ hasMenu }">
    <div class="large-navigation-bar__button-wrapper" @click="toggleMenu">
      <div class="large-navigation-bar__button">menu</div>
    </div>
    <ul class="large-navigation-bar__menu">
      <router-link tag="li" to="/about">About</router-link>
      <router-link tag="li" to="/partners">Partners</router-link>
      <router-link tag="li" to="/host">Host</router-link>
    </ul>
  </div>
</template>

<style lang="scss">
.large-navigation-bar {
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 60px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  top: 0;
  left: 0;
  transition: transform 0.33s ease-in-out;

  &.hasMenu {
    transform: translateX(-100%);
  }

  &__button {
    @extend .material-icons;
    width: 100%;
    height: 60px;
    background-color: #fc8b00;
    text-align: center;
    line-height: 60px;
    cursor: pointer;
    user-select: none;
    transition: background-color 0.13s ease-in-out;

    &:hover {
      background-color: lighten(#fc8b00, 5);
    }

    &-wrapper {
      flex: 0;
    }
  }

  &__menu {
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    transform-origin: left top;
    transform: rotate(-90deg);
    margin-top: 245px;

    @media (min-width: 100em) {
      margin-top: 331px;
    }

    li {
      display: inline-block;
      line-height: 60px;
      padding: 0 32px;
      cursor: pointer;
      font-weight: 300;
      letter-spacing: 1.48px;
      text-transform: uppercase;
      transition: background-color 0.13s ease-in-out;

      @media (min-width: 100em) {
        padding: 0 64px;
      }

      &:hover {
        background-color: rgba(0, 0, 0, 0.4);
      }
    }
  }
}
</style>

<script>
export default {
  computed: {
    hasMenu () {
      return this.$store.state.menuVisibility
    }
  },
  methods: {
    toggleMenu () {
      this.$store.commit('setMenuVisibility', !this.hasMenu)
    }
  }
}
</script>
